<!-- PAGE HEAD -->
<div class="page-head">
  <div>
    <div class="eyebrow">{{ t('catalogManagement') }}</div>
    <h2 class="title">{{ t('products') }}</h2>
  </div>

  <div class="head-stat">
    <span class="num">{{ total }}</span>
    <span class="lbl">{{ t('itemsListed') }}</span>
  </div>

  <a class="bulk-import-btn" routerLink="/admin/products/import">
    📥 {{ t('bulkImportProducts') }}
  </a>
</div>

<!-- FORM -->

<div class="form-card">

  <div class="form-card-head">
    <h3>{{ editingId ? t('editProduct') : t('addNewProduct') }}</h3>
    <p>{{ t('fillDetailsBelow') }}</p>
  </div>

  <div class="form">

    <!-- BASIC INFO -->
    <div class="field-section">
      <div class="section-label">{{ t('basicInformation') }}</div>

      <div class="field-grid cols-2">

        <div class="field">
          <label>{{ t('productNameEn') }}</label>
          <input
            [(ngModel)]="form.name"
            (blur)="autoFillNameBn()"
            placeholder="e.g. Fresh Tomato">
        </div>

        <div class="field">
          <label>{{ t('productNameBn') }} 🇧🇩</label>
          <input
            [(ngModel)]="form.nameBn"
            (blur)="autoFillNameEn()"
            placeholder="যেমন: তাজা টমেটো (ইংরেজি লিখে বাইরে ক্লিক করলে অটো বাংলা বসে যাবে)">
          <span class="hint" *ngIf="translatingName">⏳ {{ t('loading') }}</span>
          <span class="hint" *ngIf="!translatingName">{{ t('optionalLeaveBlank') }}</span>
        </div>

        <div class="field">
          <label>{{ t('category') }}</label>
          <select [(ngModel)]="form.categoryId">

            <option [ngValue]="null" disabled selected>{{ t('selectCategory') }}</option>

            <ng-container *ngFor="let main of categories">

              <option
                *ngIf="!main.children || main.children.length === 0"
                [ngValue]="main.id">
                {{ main.name }}
              </option>

              <ng-container *ngFor="let sub of main.children">

                <option
                  *ngIf="!sub.children || sub.children.length === 0"
                  [ngValue]="sub.id">
                  {{ main.name }} → {{ sub.name }}
                </option>

                <option
                  *ngFor="let child of sub.children"
                  [ngValue]="child.id">
                  {{ main.name }} → {{ sub.name }} → {{ child.name }}
                </option>

              </ng-container>

            </ng-container>

          </select>
        </div>

      </div>
    </div>

    <!-- PRICING & STOCK -->
    <div class="field-section">
      <div class="section-label">{{ t('pricingStock') }}</div>

      <div class="field-grid cols-4">

        <div class="field price-field">
          <label>{{ t('price') }}</label>
          <span class="prefix">৳</span>
          <input [(ngModel)]="form.price" type="number" placeholder="0.00">
        </div>

        <div class="field">
          <label>{{ t('packSize') }}</label>
          <select [(ngModel)]="form.unit">
            <option value="" disabled selected>{{ t('selectUnit') }}</option>
            <option value="kg">{{ t('unitKg') }}</option>
            <option value="gram">{{ t('unitGram') }}</option>
            <option value="liter">{{ t('unitLiter') }}</option>
            <option value="ml">{{ t('unitMl') }}</option>
            <option value="pcs">{{ t('unitPiece') }}</option>
            <option value="box">{{ t('unitBox') }}</option>
            <option value="dozen">{{ t('unitDozen') }}</option>
            <option value="pack">{{ t('unitPack') }}</option>
            <option value="bag">{{ t('unitBag') }}</option>
            <option value="bottle">{{ t('unitBottle') }}</option>
            <option value="can">{{ t('unitCan') }}</option>
            <option value="set">{{ t('unitSet') }}</option>
            <option value="pair">{{ t('unitPair') }}</option>
            <option value="carton">{{ t('unitCarton') }}</option>
            <option value="sachet">{{ t('unitSachet') }}</option>
            <option value="tube">{{ t('unitTube') }}</option>
            <option value="jar">{{ t('unitJar') }}</option>
            <option value="roll">{{ t('unitRoll') }}</option>
            <option value="cm">{{ t('unitCm') }}</option>
          </select>
        </div>

        <div class="field">
          <label>{{ t('quantityLabel') }}</label>
          <input [(ngModel)]="form.quantity" type="number" placeholder="e.g. 500">
        </div>

        <div class="field">
          <label>{{ t('discount') }}</label>
          <input type="number" [(ngModel)]="form.discount" placeholder="% off">
        </div>

        <div class="field">
          <label>{{ t('stock') }}</label>
          <input [(ngModel)]="form.stock" type="number" placeholder="0">
        </div>

        <div class="field">
          <label>{{ t('stockUnit') }}</label>
          <select [(ngModel)]="form.stockUnit">
            <option value="" disabled selected>{{ t('stockUnit') }}</option>
            <option value="kg">{{ t('unitKg') }}</option>
            <option value="gram">{{ t('unitGram') }}</option>
            <option value="liter">{{ t('unitLiter') }}</option>
            <option value="ml">{{ t('unitMl') }}</option>
            <option value="pcs">{{ t('unitPcs') }}</option>
            <option value="box">{{ t('unitBox') }}</option>
            <option value="dozen">{{ t('unitDozen') }}</option>
            <option value="pack">{{ t('unitPack') }}</option>
            <option value="bag">{{ t('unitBag') }}</option>
            <option value="bottle">{{ t('unitBottle') }}</option>
            <option value="can">{{ t('unitCan') }}</option>
            <option value="set">{{ t('unitSet') }}</option>
            <option value="pair">{{ t('unitPair') }}</option>
            <option value="carton">{{ t('unitCarton') }}</option>
            <option value="sachet">{{ t('unitSachet') }}</option>
            <option value="tube">{{ t('unitTube') }}</option>
            <option value="jar">{{ t('unitJar') }}</option>
            <option value="roll">{{ t('unitRoll') }}</option>
            <option value="cm">{{ t('unitCm') }}</option>
          </select>
        </div>

      </div>
    </div>

    <!-- PRODUCT DETAILS -->
    <div class="field-section">
      <div class="section-label">{{ t('productDetails') }}</div>

      <div class="field-grid cols-2">

        <div class="field">
          <label>{{ t('brand') }}</label>
          <input [(ngModel)]="form.brand" placeholder="Brand name">
        </div>

        <div class="field">
  <label>{{ t('originCountry') }}</label>

  <input
    list="countryList"
    [(ngModel)]="form.origin"
    [placeholder]="t('selectOrTypeCountry')">

  <datalist id="countryList">
    <option value="Bangladesh"></option>
    <option value="India"></option>
    <option value="China"></option>
    <option value="Pakistan"></option>
    <option value="Vietnam"></option>
    <option value="Thailand"></option>
    <option value="Malaysia"></option>
    <option value="Indonesia"></option>
    <option value="Japan"></option>
    <option value="USA"></option>
  </datalist>
</div>

      </div>

      <div class="field" style="margin-top:18px;">
        <label>{{ t('descriptionEn') }}</label>
        <textarea
          [(ngModel)]="form.description"
          (blur)="autoFillDescriptionBn()"
          placeholder="Short description shown on the product page"></textarea>
      </div>

      <div class="field" style="margin-top:18px;">
        <label>{{ t('descriptionBn') }} 🇧🇩</label>
        <textarea
          [(ngModel)]="form.descriptionBn"
          (blur)="autoFillDescriptionEn()"
          placeholder="ইংরেজি লিখে বাইরে ক্লিক করলে অটো বাংলা বসে যাবে"></textarea>
        <span class="hint" *ngIf="translatingDescription">⏳ {{ t('loading') }}</span>
      </div>
    </div>

    <!-- IMAGES -->
    <div class="field-section">
      <div class="section-label">{{ t('images') }}</div>

      <div class="field-grid cols-4">

        <div class="file-group">
          <label>{{ t('mainImage') }}</label>
          <input type="file" (change)="onFileChange($event)">
        </div>

        <div class="file-group">
          <label>{{ t('image2') }}</label>
          <input type="file" (change)="onFile2Change($event)">
        </div>

        <div class="file-group">
          <label>{{ t('image3') }}</label>
          <input type="file" (change)="onFile3Change($event)">
        </div>

        <div class="file-group">
          <label>{{ t('image4') }}</label>
          <input type="file" (change)="onFile4Change($event)">
        </div>

      </div>
    </div>

    <!-- FOOTER -->
    <div class="form-footer">

      <div class="preview-chip" *ngIf="previewUrl">
        <img [src]="previewUrl">
        <span>{{ t('mainImagePreview') }}</span>
      </div>

      <button class="btn-ghost" *ngIf="editingId" (click)="reset()">{{ t('cancel') }}</button>

      <button class="btn-primary" (click)="save()">
        {{ editingId ? t('updateProduct') : t('addProduct') }}
      </button>

    </div>

  </div>

</div>

<!-- TOOLBAR -->

<div class="toolbar">

  <div class="search-box">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="11" cy="11" r="7"/>
      <line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
    <input type="text" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" [placeholder]="t('searchProducts')">
  </div>

  <div class="toolbar-count" *ngIf="!loading && !showTrash">
    {{ t('showingLabel') }} {{ products.length }} {{ t('ofLabel') }} {{ total }}
  </div>

  <button type="button" class="delete-btn" style="margin-left:auto;" (click)="toggleTrash()">
    {{ showTrash ? '⬅️ ফিরে যান (Products)' : '🗑️ Trash' }}
  </button>

</div>

<!-- ========================= -->
<!-- 🗑️ PRODUCT TRASH PANEL -->
<!-- ========================= -->
<div *ngIf="showTrash">

  <div class="state-panel" *ngIf="trashLoading">
    <div class="spinner"></div>
    <h4>লোড হচ্ছে...</h4>
  </div>

  <div class="state-panel" *ngIf="!trashLoading && trashProducts.length === 0">
    <h4>Trash খালি</h4>
    <p>এখানে যেসব প্রোডাক্ট ডিলিট করা হয়েছে সেগুলো দেখা যাবে — ফিরিয়ে আনা বা স্থায়ীভাবে মুছে ফেলা যাবে।</p>
  </div>

  <div class="products" *ngIf="!trashLoading && trashProducts.length > 0">

    <div *ngFor="let p of trashProducts" class="card">

      <div class="image-box">
        <img [src]="getImage(p.imageUrl)" (error)="p.imageUrl=''">
      </div>

      <div class="card-body">
        <h4>{{ p.name }}</h4>
        <p style="font-size:12px;color:#888;">
          SKU: {{ p.sku }} · ডিলিট করেছেন: {{ p.deletedByName || '—' }}<br>
          ডিলিটের সময়: {{ p.deletedAt | date:'medium' }}
        </p>
      </div>

      <div class="card-actions">
        <button class="edit-fab" style="position:static;" (click)="restoreProduct(p.id)" title="ফিরিয়ে আনুন">
          ♻️ Restore
        </button>
        <button class="delete-btn" (click)="permanentDelete(p.id)">
          স্থায়ীভাবে মুছুন
        </button>
      </div>

    </div>

  </div>

</div>

<!-- LOADING STATE -->

<div class="state-panel" *ngIf="loading && !showTrash">
  <div class="spinner"></div>
  <h4>{{ t('loadingProducts') }}</h4>
  <p>{{ t('hangTightCatalog') }}</p>
</div>

<!-- EMPTY STATE -->

<div class="state-panel" *ngIf="!loading && !showTrash && filteredProducts.length === 0">
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
    <path d="M3 7l1.5-3h15L21 7M3 7v13a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7M3 7h18M9 11h6"/>
  </svg>
  <h4>{{ searchText ? t('noMatchingProducts') : t('noProductsYet') }}</h4>
  <p>
    {{ searchText
      ? t('tryDifferentSearch')
      : t('addFirstProduct') }}
  </p>
</div>

<!-- PRODUCTS -->

<div class="products" *ngIf="!loading && !showTrash && filteredProducts.length > 0">

  <div *ngFor="let p of filteredProducts" class="card">

    <!-- IMAGE -->
    <div class="image-box">

      <span class="discount-tag" *ngIf="p.discount">-{{ p.discount | bnNumber }}%</span>

      <img [src]="getImage(p.imageUrl)" (error)="p.imageUrl=''">

      <button class="edit-fab" (click)="edit(p)" title="Edit product">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 20h9"/>
          <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/>
        </svg>
      </button>

    </div>

    <!-- INFO -->
    <div class="info">

      <h3>{{ languageService.productName(p) }}</h3>

      <!-- CATEGORY BREADCRUMB -->
      <p class="cat">

        <ng-container *ngIf="p.category?.parent?.parent">
          {{ p.category.parent.parent.name }}
          <span class="sep">›</span>
          {{ p.category.parent.name }}
          <span class="sep">›</span>
          {{ p.category.name }}
        </ng-container>

        <ng-container *ngIf="p.category?.parent && !p.category?.parent?.parent">
          {{ p.category.parent.name }}
          <span class="sep">›</span>
          {{ p.category.name }}
        </ng-container>

        <ng-container *ngIf="!p.category?.parent">
          {{ p.category?.name }}
        </ng-container>

      </p>

      <!-- SKU + BRAND -->
      <p class="cat" *ngIf="p.sku || p.brand">
        <span *ngIf="p.sku">SKU: {{ p.sku }}</span>
        <span *ngIf="p.sku && p.brand" class="sep">›</span>
        <span *ngIf="p.brand">{{ p.brand }}</span>
      </p>

      <!-- PRICE -->
      <div class="price-row">
        <span class="price">{{ getFinalPrice(p) | bnNumber:'৳ ' }}</span>
        <span class="price-old" *ngIf="p.discount">{{ p.price | bnNumber:'৳ ' }}</span>
      </div>

      <!-- QUANTITY + STOCK -->
      <div class="meta-row">

        <span class="unit" *ngIf="p.quantity && p.unit">
          {{ p.quantity | bnNumber }} {{ languageService.translateUnit(p.unit) }}
        </span>

        <span
          class="stock"
          [ngClass]="{ 'low': p.stock > 0 && p.stock <= 5, 'out': p.stock == 0 }">
          {{ p.stock | bnNumber }} {{ p.stockUnit | uppercase }}
        </span>

      </div>

      <!-- ACTIONS -->
      <div class="actions">

        <button class="edit-btn" (click)="edit(p)">{{ t('edit') }}</button>
        <button class="delete-btn" (click)="delete(p.id)">{{ t('delete') }}</button>

      </div>

    </div>

  </div>

</div>

<!-- LOAD MORE -->
<div *ngIf="!loading && !showTrash && hasMore" style="text-align:center; margin:18px 0;">
  <button type="button" class="edit-btn" (click)="loadMore()" [disabled]="loadingMore">
    {{ loadingMore ? t('loading') : 'আরও দেখুন (Load more)' }}
  </button>
</div>
